import get from 'lodash/get';
import isFunction from 'lodash/isFunction';

export async function getEditorData(editorRef) {
  try {
    const editorInstance = get(editorRef, 'current.instance');
    const isEditorEmpty = await editorInstance.isEmpty();

    if (isEditorEmpty) return null;

    return await editorInstance.getData();
  } catch (e) {
    Logger.error('StructureEditor getEditorData failed with error:', e);
    return null;
  }
}

export function importStructure(editorRef, structure) {
  const editorInstance = get(editorRef, 'current.instance');
  try {
    if (isFunction(editorInstance.importStructure)) {
      return editorInstance.importStructure(structure);
    }
    return editorInstance.loadStructure(structure);
  } catch (e) {
    return Logger.reject('StructureEditor loadStructure failed with error:', e);
  }
}

export function loadStructure(editorRef, structure) {
  const editorInstance = get(editorRef, 'current.instance');
  try {
    return editorInstance.loadStructure(structure);
  } catch (e) {
    return Logger.reject('StructureEditor loadStructure failed with error:', e);
  }
}

export function clearEditor(editorRef) {
  const editorInstance = get(editorRef, 'current.instance');
  try {
    editorInstance.clear();
  } catch (e) {
    Logger.error('StructureEditor clear failed with error:', e);
  }
}
